function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5 1c-.94 0-1.81.33-2.5.88A3.97 3.97 0 001 5c0 2.21 1.79 4 4 4a4 4 0 002.64-1C8.47 7.27 9 6.2 9 5c0-2.21-1.79-4-4-4zm1 4.25c0 .26-.14.51-.36.64l-1.25.75c-.12.07-.25.11-.38.11-.25 0-.5-.13-.64-.36-.21-.36-.1-.82.26-1.03l.89-.53V3.75c0-.41.34-.75.75-.75s.75.34.75.75v1.5H6z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15 3v9c0 1.1-.9 2-2 2H2V7.62c.73.87 1.85 1.41 3.09 1.38 1.01-.02 1.92-.41 2.6-1.06.31-.26.57-.59.77-.95.36-.61.56-1.33.54-2.08-.03-1.17-.55-2.2-1.36-2.91H14c.55 0 1 .45 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 14v3c0 1.66-1.34 3-3 3h-1c0-1.1-.9-2-2-2s-2 .9-2 2h-4c0-1.1-.9-2-2-2s-2 .9-2 2H5c-1.66 0-3-1.34-3-3v-3h11c1.1 0 2-.9 2-2V5h1.84c.72 0 1.38.39 1.74 1.01L20.29 9H19c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M8 22a2 2 0 100-4 2 2 0 000 4zm8 0a2 2 0 100-4 2 2 0 000 4zm6-9.47V14h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1.29l1.45 2.54c.17.3.26.64.26.99z"
})));